export default __webpack_public_path__ + "static/media/docterSection.6c1f4163.png";